export {AssetProjectViewActivityContainer as AssetProjectViewActivity} from './AssetProjectViewActivityContainer';
export {ProjectViewActivityContainer as ProjectViewActivity} from './ProjectViewActivityContainer';



// WEBPACK FOOTER //
// ./src/js/projects/components/ProjectViewActivity/index.js